<template>
  <div>
    <TransactionsList
      :isSubTab="isSubTab"
      :payoutData="payoutData"
      :payoutsTransactions="true"
    >
    <template v-slot:footerButtons>
      <div class="fixed-footer">
        <div class="d-flex justify-content-end">
          <b-button v-if="canEdit" class="btn-outline-dark mr-3" @click="prevTab">
            {{ $t("modify_scope") | capitalize }}
          </b-button>
          <b-button class="mr-3 btn-outline-red" @click="generateReports" v-if="payoutData.status === payoutStatuses.IN_REVIEW">
            {{ $t("generate_report") | capitalize }}
          </b-button>    
        </div>
      </div>
    </template>
  </TransactionsList>
  </div>
</template>

<script>
import TransactionsList from "@/pages/Transactions/TransactionsList.vue"
import { payoutStatuses } from "@/constants"
export default {
  name: "TransactionsSection",
  components: { TransactionsList },
  props: {
    isSubTab: Boolean,
    payoutData: Object,
    canEdit: Boolean,
  },
  data () {
    return {
      payoutStatuses,
    }
  },
  methods: {
    prevTab () {
      this.$parent.$parent.previousTab()
    },
    generateReports () {
      this.$api.payouts.generateReports(this.payoutData.id)
    }
  }
}
</script>
